import { Typography, useTheme } from '@mui/material';

import { Card } from 'src/components';
import PaymentHistoryTable from 'src/pages/ViewSalesInvoicePage/components/InvoicePaymentHistory/PaymentHistoryTable';
import { selfBillingInvoice } from 'types/graphql';
const InvoicePaymentHistory = ({
    invoice,
    currencySymbol,
}: {
    invoice: selfBillingInvoice['selfBillingInvoice'];
    currencySymbol: string;
}) => {
    const theme = useTheme();

    return (
        <Card color={theme.palette.text.primary} flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Invoice Payment History
            </Typography>

            <PaymentHistoryTable
                currency={currencySymbol}
                paymentLogs={[]}
                onPaymentToDelete={(payment) => {
                    // TODO in a future developments
                }}
            />
        </Card>
    );
};
export default InvoicePaymentHistory;
